import { useMutation } from '@tanstack/react-query';
import { useNavigate } from 'react-router-dom';

import { endpoints } from 'global/endpoints';
import { useIntegrationStore } from 'store/useIntegrationStore';
import http from 'utils/http';

const connectPaychex = () => {
  const newEndpoints = endpoints.integrations.paychexConnect;
  return http().post(newEndpoints, {});
};

export function useConnectPaychex() {
  const navigate = useNavigate();
  const addIntegrationList = useIntegrationStore(state => state.addIntegrationList);
  return useMutation({
    mutationFn: connectPaychex,
    onSuccess: ({ payload }) => {
      addIntegrationList(payload);
      navigate('/integrations/paychex/mapping');
    },
  });
}
